import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Accolade } from '../../../clients'

type AccoladeStoreType = Omit<Accolade,
    'createdAt' | 'updatedAt'
> & {
    createdAt: string,
    updatedAt: string
}

interface AccoladesState {
    accolades: AccoladeStoreType[]
}

const initialState: AccoladesState = {
    accolades: [],
}

const accoladesSlice = createSlice({
    name: 'accolades',
    initialState,
    reducers: {
        setAccolades(state, payload: PayloadAction<AccoladeStoreType[]>) {
            state.accolades = payload.payload
        },
        addAccolade(state, payload: PayloadAction<AccoladeStoreType>) {
            state.accolades.push(payload.payload)
        },
        updateAccolade(state, payload: PayloadAction<AccoladeStoreType>) {
            const index = state.accolades.findIndex(x => x.id === payload.payload.id)
            state.accolades[index] = payload.payload
        }
    }
})

export const { setAccolades, addAccolade, updateAccolade } = accoladesSlice.actions
export default accoladesSlice.reducer